/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * tdm
 * OpenAPI spec version: v1.0.0
 */
import type {
  MemberAddRequest,
  MemberEpisode,
  MemberSelfUpdateRequest,
  MemberUpdateRequest,
  PageEpisodeParams,
  PageMemberParams,
  ResetPassword,
  ResultListMemberCache,
  ResultListStationedManga,
  ResultMemberInfoVO,
  ResultPageBeanMemberEpisodeVO,
  ResultPageBeanMemberListVO,
  ResultVoid
} from '../models';

import { customInstance } from '../../core/mutator';



  export const getMemberController = () => {
/**
 * @summary 新增组员
 */
const newMember = (
    memberAddRequest: MemberAddRequest,
 ) => {
      return customInstance<ResultVoid>(
      {url: `/api/members`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: memberAddRequest
    },
      );
    }
  /**
 * @summary 分页查询组员信息
 */
const pageMember = (
    params: PageMemberParams,
 ) => {
      return customInstance<ResultPageBeanMemberListVO>(
      {url: `/api/members`, method: 'GET',
        params
    },
      );
    }
  /**
 * @summary 修改组员
更新组员的基本信息和职位信息
 */
const updateMember = (
    memberUpdateRequest: MemberUpdateRequest,
 ) => {
      return customInstance<ResultVoid>(
      {url: `/api/members`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: memberUpdateRequest
    },
      );
    }
  /**
 * @summary 查询全体组员列表
 */
const getMemberList = (
    
 ) => {
      return customInstance<ResultListMemberCache>(
      {url: `/api/members/all`, method: 'GET'
    },
      );
    }
  /**
 * @summary 批量删除组员
根据ID列表批量删除组员，删除前会检查组员是否已绑定漫画
 */
const deleteMember = (
    ids: { [key: string]: unknown },
 ) => {
      return customInstance<ResultVoid>(
      {url: `/api/members/${ids}`, method: 'DELETE'
    },
      );
    }
  /**
 * @summary 根据id查询单个组员（为了修改）
 */
const getMemberById = (
    id: number,
 ) => {
      return customInstance<ResultMemberInfoVO>(
      {url: `/api/members/${id}`, method: 'GET'
    },
      );
    }
  /**
 * @summary 组员自己修改昵称和QQ号
 */
const updateMemberSelf = (
    memberSelfUpdateRequest: MemberSelfUpdateRequest,
 ) => {
      return customInstance<ResultVoid>(
      {url: `/api/members/self`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: memberSelfUpdateRequest
    },
      );
    }
  /**
 * @summary 查询组员常驻的漫画(不分页）
 */
const findStationedMangas = (
    id: number,
 ) => {
      return customInstance<ResultListStationedManga>(
      {url: `/api/members/stationedMangas/${id}`, method: 'GET'
    },
      );
    }
  /**
 * @summary 更新组员密码
 */
const updateMemberPassword = (
    resetPassword: ResetPassword,
 ) => {
      return customInstance<ResultVoid>(
      {url: `/api/members/updatepwd`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: resetPassword
    },
      );
    }
  /**
 * @summary 查询组员做过的所有话数并分页
 */
const pageEpisode = (
    params: PageEpisodeParams,
 ) => {
      return customInstance<ResultPageBeanMemberEpisodeVO>(
      {url: `/api/members/memberepisode`, method: 'GET',
        params
    },
      );
    }
  /**
 * @summary 组员接稿
 */
const takeEpisode = (
    memberEpisode: MemberEpisode,
 ) => {
      return customInstance<ResultVoid>(
      {url: `/api/members/takeEpisode`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: memberEpisode
    },
      );
    }
  /**
 * @summary 组员交稿
 */
const submitEpisode = (
    memberEpisode: MemberEpisode,
 ) => {
      return customInstance<ResultVoid>(
      {url: `/api/members/submitEpisode`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: memberEpisode
    },
      );
    }
  return {newMember,pageMember,updateMember,getMemberList,deleteMember,getMemberById,updateMemberSelf,findStationedMangas,updateMemberPassword,pageEpisode,takeEpisode,submitEpisode}};
export type NewMemberResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMemberController>['newMember']>>>
export type PageMemberResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMemberController>['pageMember']>>>
export type UpdateMemberResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMemberController>['updateMember']>>>
export type GetMemberListResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMemberController>['getMemberList']>>>
export type DeleteMemberResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMemberController>['deleteMember']>>>
export type GetMemberByIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMemberController>['getMemberById']>>>
export type UpdateMemberSelfResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMemberController>['updateMemberSelf']>>>
export type FindStationedMangasResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMemberController>['findStationedMangas']>>>
export type UpdateMemberPasswordResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMemberController>['updateMemberPassword']>>>
export type PageEpisodeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMemberController>['pageEpisode']>>>
export type TakeEpisodeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMemberController>['takeEpisode']>>>
export type SubmitEpisodeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMemberController>['submitEpisode']>>>
